import React from 'react';
import { LegalPage } from '../components/LegalPage';
interface AdaPageProps {
  language: 'en' | 'es';
}
export function AdaPage({
  language
}: AdaPageProps) {
  const content = {
    en: {
      title: 'ADA COMPLIANCE STATEMENT',
      sections: [{
        heading: 'OUR COMMITMENT',
        paragraphs: ['Blackstone Rentals LLC is committed to ensuring accessibility for people with disabilities. We continually improve the user experience for everyone who visits our site or uses our services.']
      }, {
        heading: 'ADA-COMPLIANT PORTABLE RESTROOM UNITS',
        paragraphs: ['We offer ADA-compliant portable restroom units available for rent featuring:', 'Extra-wide interior space, handrails for stability, accessible door handles, and meets ADA Standards for Accessible Design.']
      }, {
        heading: 'WEBSITE ACCESSIBILITY',
        paragraphs: ['We strive to make our website accessible:', 'Alt text on all images, readable font sizes, color contrast compliance, mobile-friendly design, and bilingual content (English/Spanish).']
      }, {
        heading: 'CONTACT FOR ASSISTANCE',
        paragraphs: ['If you need accessibility assistance:', 'Blackstone Rentals LLC — Odessa, Texas', 'Phone: 432-528-7892 | 432-803-4737', 'Email: blackstonerentals.99@gmail.com', 'Available 24/7']
      }]
    },
    es: {
      title: 'DECLARACIÓN DE CUMPLIMIENTO ADA',
      sections: [{
        heading: 'NUESTRO COMPROMISO',
        paragraphs: ['Blackstone Rentals LLC está comprometido a garantizar accesibilidad para personas con discapacidades. Mejoramos continuamente la experiencia para todos los visitantes y usuarios de nuestros servicios.']
      }, {
        heading: 'UNIDADES PORTÁTILES ADA',
        paragraphs: ['Ofrecemos unidades de baño portátil que cumplen con ADA para renta:', 'Espacio interior extra amplio, pasamanos para estabilidad, manijas de puerta accesibles, y cumple con Estándares ADA de Diseño Accesible.']
      }, {
        heading: 'ACCESIBILIDAD DEL SITIO WEB',
        paragraphs: ['Nos esforzamos por hacer el sitio accesible:', 'Texto alternativo en todas las imágenes, tamaños de fuente legibles, contraste de colores adecuado, diseño adaptable a móviles, y contenido bilingüe (inglés/español).']
      }, {
        heading: 'CONTACTO PARA ASISTENCIA',
        paragraphs: ['Si necesita asistencia de accesibilidad:', 'Blackstone Rentals LLC — Odessa, Texas', 'Teléfono: 432-528-7892 | 432-803-4737', 'Email: blackstonerentals.99@gmail.com', 'Disponible 24/7']
      }]
    }
  };
  const t = content[language];
  return <LegalPage language={language} title={t.title} lastUpdated="January 1, 2026" sections={t.sections} data-id="element-407" />;
}